export const OPEN_COOKIE_SETTINGS_EVENT = "rivetai:open-cookie-settings";

export function openCookieSettings(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
}
